import { Grid, Skeleton, Stack } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';

import { FormSubsection } from '../../ui/FormSubsection.js';
import { DECIMAL_INPUT_PROPS } from '../../form/numberFieldPresets.js';
import { ValidatedNumberInput } from '../../form/validatedFields.js';
import type { EnvironmentalDataFormData } from '../../../types/reports.js';

interface StromSectionProps {
  form: UseFormReturnType<EnvironmentalDataFormData>;
  disabled?: boolean;
  loading?: boolean;
}

export function StromSection({ form, disabled, loading }: StromSectionProps) {
  if (loading) {
    return (
      <Grid>
        {Array.from({ length: 2 }, (_, i) => i).map((i) => (
          <Grid.Col span={{ base: 12, md: 6 }} key={i}>
            <Skeleton height={60} />
          </Grid.Col>
        ))}
      </Grid>
    );
  }

  return (
    <Stack>
      <FormSubsection title="Elektrischer Energieverbrauch">
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <ValidatedNumberInput
              form={form}
              field="electricityConsumptionTotal"
              kind="decimal"
              label="Absoluter elektrischer Energieverbrauch - Gesamt"
              disabled={disabled}
              unit="kWh"
              {...DECIMAL_INPUT_PROPS}
            />
          </Grid.Col>
        </Grid>
      </FormSubsection>

      <FormSubsection title="Abwärmenutzung">
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <ValidatedNumberInput
              form={form}
              field="wasteHeatGenerationTotal"
              kind="decimal"
              label="Stromerzeugung aus Abwärme - Gesamt"
              disabled={disabled}
              unit="kWh"
              {...DECIMAL_INPUT_PROPS}
            />
          </Grid.Col>
        </Grid>
      </FormSubsection>
    </Stack>
  );
}
